package club.srams.website.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.*
import kotlin.time.Duration.Companion.milliseconds

/**
 *
 *
 * @param [images]
 * @param [autoPlayMs]
 * @param [fadeDurationMs]
 * @param [modifier]
 * @param [imageModifier]
 *
 *
 */
@Composable
fun CarouselFade(
    images: List<Pair<String, String>>,
    autoPlayMs: Long = 3000L,
    fadeDurationMs: Int = 750,
    modifier: Modifier = Modifier,
    imageModifier: Modifier = Modifier
        .fillMaxWidth()
        .height(400.px)
        .objectFit(ObjectFit.Cover),
) {
    var currentIndex by remember { mutableStateOf(0) }

    LaunchedEffect(Unit) {
        while (true) {
            delay(autoPlayMs.milliseconds)
            currentIndex = (currentIndex + 1) % images.size
        }
    }

    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .position(Position.Relative)
            .overflow(Overflow.Hidden)
            .borderRadius(12.px)
    ) {
        // All images stacked; only the active one is fully opaque
        images.forEachIndexed { i, (src, alt) ->
            Image(
                src = src
                , alt = alt
                , modifier = imageModifier
                    .position(Position.Absolute)
                    .top(0.px)
                    .left(0.px)
                    .opacity(if (i == currentIndex) 1.0 else 0.0)
                    .styleModifier {
                        property("transition", "opacity ${fadeDurationMs}ms ease-in-out")
                    }
            )
        }

        // Left arrow
        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier
                .position(Position.Absolute)
                .left(12.px)
                .size(40.px)
                .borderRadius(50.percent)
                .backgroundColor(rgba(0, 0, 0, 0.5))
                .cursor(Cursor.Pointer)
                .onClick { currentIndex = (currentIndex - 1 + images.size) % images.size }
        ) {
            SpanText("‹", modifier = Modifier.color(Colors.White).fontSize(24.px))
        }

        // Right arrow
        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier
                .position(Position.Absolute)
                .right(12.px)
                .size(40.px)
                .borderRadius(50.percent)
                .backgroundColor(rgba(0, 0, 0, 0.5))
                .cursor(Cursor.Pointer)
                .onClick { currentIndex = (currentIndex + 1) % images.size }
        ) {
            SpanText("›", modifier = Modifier.color(Colors.White).fontSize(24.px))
        }

        // Dot indicators
        Row(
            horizontalArrangement = Arrangement.spacedBy(8.px),
            modifier = Modifier
                .position(Position.Absolute)
                .bottom(12.px)
        ) {
            images.indices.forEach { i ->
                Box(
                    modifier = Modifier
                        .size(10.px)
                        .borderRadius(50.percent)
                        .backgroundColor(
                            if (i == currentIndex) Colors.White
                            else rgba(255, 255, 255, 0.5)
                        )
                        .cursor(Cursor.Pointer)
                        .onClick { currentIndex = i }
                )
            }
        }
    }
}